import React from "react";
import { Youtube, Instagram, Music2 } from "lucide-react";
import { cleanUrl } from "@/lib/format";

const BUTTONS = [
  { field: "youtube_url", label: "YouTube", icon: Youtube, brand: "bg-red-50 text-red-700 border-red-200 hover:bg-red-100" },
  { field: "instagram_url", label: "Instagram", icon: Instagram, brand: "bg-pink-50 text-pink-700 border-pink-200 hover:bg-pink-100" },
  { field: "soundcloud_url", label: "SoundCloud", icon: Music2, brand: "bg-orange-50 text-orange-700 border-orange-200 hover:bg-orange-100" },
];

export default function PortfolioButtons({ profile, size = "md" }) {
  const items = BUTTONS.map((b) => ({ ...b, url: cleanUrl(profile?.[b.field]) })).filter((x) => x.url);
  if (items.length === 0) return null;
  const cls = size === "sm" ? "text-xs px-2.5 py-1" : "text-sm px-3 py-1.5";
  return (
    <div className="flex flex-wrap gap-2">
      {items.map((b) => (
        <a key={b.field} href={b.url} target="_blank" rel="noreferrer"
          data-testid={`portfolio-${b.field}`}
          className={`inline-flex items-center gap-1.5 rounded-full border font-medium transition-colors ${b.brand} ${cls}`}>
          <b.icon className="w-3.5 h-3.5" /> {b.label}
        </a>
      ))}
    </div>
  );
}
